'use strict'; /* eslint-disable no-console */

const quantity = (function() {

	function adjustQuantity(e) {
		e.preventDefault();
		const button = e.currentTarget;
		const input = document.getElementById(button.dataset.id);
		const adjust = button.dataset.input;
		let value = parseInt(input.value);

		// console.log(e);

		if( adjust == 'add' ){
			input.value = value += 1;
		}else{
			input.value = (value <= 0) ? 0 : value -= 1;
		}
	}


	function init() {
		const buttons = document.querySelectorAll('.js-number-button');

		[].forEach.call(buttons, (button) => {
			button.addEventListener('click', adjustQuantity);
		});

	}

	window.addEventListener('DOMContentLoaded', init);
})();

export default quantity;


// WEBPACK FOOTER //
// ./resources/assets/js/quantity-input.js